<template>
  <v-main>
    <v-container class="pa-1 pa-lg-3">
      <v-card flat>
        <div class="px-0 mt-2 h1 black--text">{{pointName}}</div>
        <v-divider class="mb-2"></v-divider>

        <div
          v-for="item in items"
          :key="item.id"
        >
          <AuditItem
            v-if="item.child"
            :item="item"
          ></AuditItem>
        </div>

        <v-card-actions class="pa-1 mt-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-4"
            :loading="submiting"
            @click="sendClick()"
          >
            Отправить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>

</template>

<script>
import HandledError from '@/utils/handledError'
import AuditItem from '@/components/AuditItem.vue'

export default {
  data: () => ({
    submiting: false,
    pointName: '',
    items: [],
    sum: 0
  }),

  created: function () {
    this.$loading(true)
    this.axios.get('/audit/getAuditData')
      .then((response) => {
        this.pointName = response.data.pointName
        this.items = response.data.items
      })
      .catch((err) => {
        if (err instanceof HandledError) return
        // Ошибка в js
        this.$router.push(`/error?message=${err.message}&from=${this.$router.currentRoute.path}`)
      })
      .then(() => {
        this.$loading(false)
      })
  },

  methods: {
    sendClick: function () {
      this.sum = 0
      let xml = '<Violations>'
      this.items.forEach(i => {
        this.buildXml(i).forEach(e => {
          xml += e
        })
      })
      xml += '</Violations>'

      this.$confirm('Отправить данные?')
        .then((result) => {
          if (!result) return
          this.submiting = true
          this.axios
            .post('/audit/inspect/', {
              xml,
              sum: this.sum
            })
            .then((response) => {
              this.submiting = false
              this.$router.push('/')
            })
        })

      this.submiting = false
    },

    buildXml (item) {
      const added = []
      if (item.child && item.child.length) {
        // если это злоебучий ненавистный radioGroup
        if (item.isRadio && item.isChecked) {
          added.push(`<Violation Text ="${item.name}">`)
          const varian = item.child.filter(x => x.id === item.balls)[0]
          added.push(`<Varian VarianText = "${varian.name}" Balls = "${varian.balls}"/>`)
          this.sum += varian.balls
          added.push('</Violation>')
          return added
        }

        // рекурсия
        item.child.forEach(c => {
          const addedChilds = this.buildXml(c)
          addedChilds.forEach(c => {
            added.push(c)
          })
        })

        if (added.length) {
          // добавить родака
          added.unshift(`<ViolationHeader Header = "${item.name}">`)
          added.push('</ViolationHeader>')
        }
      } else {
        // добавляем пункты
        if (item.isChecked) {
          added.push(`<Violation Text ="${item.name}" Balls = "${item.balls}"/>`)
          this.sum += item.balls
        }
      }
      return added
    }

  },

  components: {
    AuditItem
  }
}
</script>
